import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { A11yNotice } from "./notice.js";
import { useA11yDispatcher } from "../../hooks/useA11yDispatcher.js";
import { useCustomizeValues } from "../../hooks/useCustomizeValues.js";
import { getSidebarCustomize } from "../../sidebar/getSidebarCustomize.js";
import { __ } from "../../utils/i18n.js";
const A11yFontWeight = (param)=>{
    let { settings, severity, notAccessible, modifier } = param;
    const customize = getSidebarCustomize();
    const values = useCustomizeValues(settings);
    const hasError = useMemo(()=>{
        const fontWeight = modifier ? modifier(values[settings[0]].value, settings.slice(1).reduce((p, c)=>{
            p.push(values[c].value);
            return p;
        }, []), (setting)=>customize(setting).get()) : values[settings[0]].value;
        return notAccessible.indexOf(fontWeight) > -1 ? fontWeight : false;
    }, [
        JSON.stringify(values),
        notAccessible
    ]);
    useA11yDispatcher({
        setting: settings[0],
        valid: hasError === false
    });
    if (!hasError) {
        return null;
    }
    return /*#__PURE__*/ _jsx(A11yNotice, {
        severity: severity,
        text: __('We do not recommend to use the font weight "%s" to comply with the {{aPerc}}"perceptibility" of the WCAG 2.2 standard{{/aPerc}} and thereby meet the {{aEuMinimum}}EU\'s minimum legal requirements for accessibility{{/aEuMinimum}}.', hasError)
    });
};
export { A11yFontWeight };
